<template>  <!-- Split edit -->
	<section>
		<!--Toolbar -->
		<el-col :span="24" style="padding-bottom: 0px;margin-top:20px">
		  <el-form style='min-height:450px;' :model="editForm" label-width="120px" 
               :rules="editFormRules" ref="editForm">
				<el-tabs type='card'>
          
					<!-- ----------------------------------------------------------------- -->
					<el-tab-pane> <span slot='label'><i class='el-icon-date'></i> Import</span> 
          <el-form-item label="Site:" prop="site">
	  			  <el-select size='small' style='width:200px' v-model="sitecode" Placeholder='Select Site'>
            <el-option v-for="item in sites" 
        		           :key='item.code' 
			 	               :label="item.code + ' - ' + item.name" 
			  	    				 :value='item.code'></el-option>
    		    </el-select>
	  			</el-form-item>

          <!--<el-form-item label="Site:" prop="site">
					<el-input  v-model="sitecode" auto-complete="off"></el-input>
			  	</el-form-item>
          -->
          <el-form-item label="XML : ">
            <el-input type='textarea' rows='30' style='font-family:system;font-size:12px' v-model="xmldata"></el-input>
          </el-form-item>
        </el-tab-pane>

					<!-- ----------------------------------------------------------------- -->
        
				</el-tabs>

				<span style='margin-top:20px'>					
          <br/>	  	
	  			<el-button style='float:right;' type='primary' icon="Upload" @click.native="Upload">Import</el-button>
          <el-button style='float:left;' type="default" @click.native="closeForm" icon="edit" :loading="editLoading">Close</el-button>
        </span>


			</el-form>
			

		</el-col>

	</section>
</template>

<script>
	import util     from '../../common/AppUtil';
  import settings from '../../common/AppSettings';
  import text     from '../../common/AppText';
  import api      from '../../api/bas/dossier';

	export default {
	  // hideModules: { "bold": false },		
		data() {
			return {
        QID         : util.Initialize(this.$router,"DOS"),
        util        : util,
        stack       : {},
			  lang        : text.data,
				APICode     : "BasDossierImport",
				mainFunc    : "Dossier XML",
				mainSubject : "Dossier",
        mainKey     : "dossierid",
				mainKeyDesc : "dossierid",
        sitecode    : "",
        sites : [],

				data: [],    // All base/api data (Excluding generic) 
				session: {},
				content: [],
				counter: {},
				related: {},
        xmldata: "",
        xmlfile: "",
				listLoading:     false,  // Indicator list is loading
				editForm:        {},     // list of fields in the editform
				editFormVisible: false,  // Of de bewerkingsinterface wordt weergegeven
				editLoading:     false,  // Indicator edit is loading
        editMode:        '',     // ADD or SAVE mode for current rec
				editTitle:       '',     // Title of the form ('add ...' or 'modify ...')
				
				editFormRules: {         // Any form validation per field
					name: [
						{ required: true, message: text.data.mandatory, trigger: 'blur' }
					]
				},

			}
		},
		methods: {

      htmlData(val) {
   			var ret = "" + val;
				return ret.replace(/\\/g, '');
      },

			// Function to retrieve all data for the current page
			getRecords() {
				this.listLoading = true;

				let parg = this.stack;

        /*
        api.execute("xml",parg).then((res) => {					
          util.processMainResults(res);
          this.editForm = util.getMainPayload(this.APICode);
          this.xmldata = util.getMainPayload("xmldata");
          this.xmlfile = util.getMainPayload("xmlfile");
  		    this.editFormVisible = true;
          this.listLoading = false;
				});
        */
			},

			// Event for submitting edit form
 	  	closeForm: function () {
         this.selectorVisible = false;
         let parg = this.stack;
         util.Forward(this.$router,"DOS",parg);
    	},	
      
      Upload: function() {

        var parg = {};
        parg["Module"] = "BasDossierImport";
        parg["Action"] = "Import";
        parg["Content"] = this.xmldata;
        parg["Params"] = {};
        parg["Params"]["site"] = this.sitecode;

        api.importDossier(parg).then((res) => {					
          util.processMainResults(res);
          this.editForm = util.getMainPayload(this.APICode);
  		    this.editFormVisible = true;
          this.listLoading = false;
          this.closeForm();
				});



      },
		},
	
		// Initial loader of data (initialize page)
		mounted() {		       
      window.addEventListener("popstate", (event) => {
        this.closeForm();
      });
      
      if (this.$route.params) {
        this.stack = this.$route.params;
        this.sites = this.stack.Params.sites;
        if(this.$route.site) this.sitecode = this.$route.site;
        else this.sitecode = this.sitecode = this.sites[0].code;
      }
      
			this.getRecords();
		}
	}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// Dossier_import.vue?58b58e0e